import { THEME } from 'styles/themes';

export const colors = THEME.Public.colors ?? {};

export const typography = THEME.Public.typography ?? {};

export const options = THEME.Public.options ?? {};
